import { TVisibleForm, TTypeOfModalWindow, IInitialFormData } from './editModifierGroupsContext';
import {
	ICreateModifierGroupValidationError,
	IItemForGetShortInfo,
	IServerError,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	IModifiersForModifierGroupsInfo,
	IUpdateModifierGroups,
	IDishesByRestaurantIdsAndSubcategoryIdsItem,
} from 'types';

export enum EditModifierGroupsActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_LOADER_STATUS = 'CHANGE_LOADER_STATUS',
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	SET_IDS_IS_FORCE_DISABLED_RESTAURANT = 'SET_IDS_IS_FORCE_DISABLED_RESTAURANT',
	SET_FETCHED_CATEGORIES = 'SET_FETCHED_CATEGORIES',
	SET_IDS_CATEGORIES = 'SET_IDS_CATEGORIES',
	SET_FETCHED_SUBCATEGORIES = 'SET_FETCHED_SUBCATEGORIES',
	SET_IDS_SUBCATEGORIES = 'SET_IDS_SUBCATEGORIES',
	SET_FETCHED_DISHES = 'SET_FETCHED_DISHES',
	SET_IDS_DISHES = 'SET_IDS_DISHES',
	CHANGE_NAME_OF_MODIFIER_GROUP = 'CHANGE_NAME_OF_MODIFIER_GROUP',
	CHANGE_EXTERNAL_ID = 'CHANGE_EXTERNAL_ID',
	SET_DEFAULT_CUSTOMER_LANGUAGE = 'SET_DEFAULT_CUSTOMER_LANGUAGE',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditModifierGroupsActionTypes.REFETCH_DATA;
	payload: {
		needRefetch: boolean;
	};
}

interface ISetInitialFormData {
	type: EditModifierGroupsActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditModifierGroupsActionTypes.SET_ALL_DATA;
	payload: {
		modifierGroupsID: string;
		initialIDSelectedCustomer: Nullable<string>;
		initialIDsSelectedRestaurant: string[];
		IDsIsForceDisabledRestaurant: string[];
		initialIDsSelectedCategories: string[];
		initialIDsSelectedSubcategories: string[];
		initialIDsSelectedDishes: string[];
		nameOfModifierGroup: string;
		modifiersOfModifierGroups: IModifiersForModifierGroupsInfo[];
		externalId: string;
		articleNumber: Nullable<string>;
		translations: IMenuTranslation[];
	};
}

interface IChangeLoaderStatus {
	type: EditModifierGroupsActionTypes.CHANGE_LOADER_STATUS;
	payload: {
		isLoading: boolean;
	};
}

interface IChangeVisibleForm {
	type: EditModifierGroupsActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TVisibleForm;
	};
}

interface ISetFetchedCustomers {
	type: EditModifierGroupsActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		customers: IItemForGetShortInfo[];
	};
}

interface ISetIDCustomer {
	type: EditModifierGroupsActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: Nullable<string>;
	};
}

interface ISetFetchedRestaurants {
	type: EditModifierGroupsActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		restaurants: IItemForGetShortInfo[];
	};
}

interface ISetIDsRestaurant {
	type: EditModifierGroupsActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: string[];
		IDsIsForceDisabledRestaurant: string[];
	};
}

interface ISetIDsIsForceDisabledRestaurant {
	type: EditModifierGroupsActionTypes.SET_IDS_IS_FORCE_DISABLED_RESTAURANT;
	payload: {
		IDsIsForceDisabledRestaurant: string[];
	};
}

interface ISetFetchedCategories {
	type: EditModifierGroupsActionTypes.SET_FETCHED_CATEGORIES;
	payload: {
		fetchedCategories: IItemForGetShortInfo[];
	};
}

interface ISetIDsCategories {
	type: EditModifierGroupsActionTypes.SET_IDS_CATEGORIES;
	payload: {
		IDsSelectedCategories: string[];
	};
}

interface ISetFetchedSubcategories {
	type: EditModifierGroupsActionTypes.SET_FETCHED_SUBCATEGORIES;
	payload: {
		fetchedSubcategories: IItemForGetShortInfo[];
	};
}

interface ISetIDsSubcategories {
	type: EditModifierGroupsActionTypes.SET_IDS_SUBCATEGORIES;
	payload: {
		IDsSelectedSubcategories: string[];
	};
}

interface ISetFetchedDishes {
	type: EditModifierGroupsActionTypes.SET_FETCHED_DISHES;
	payload: {
		dishes: IDishesByRestaurantIdsAndSubcategoryIdsItem[];
	};
}

interface ISetIDsDishes {
	type: EditModifierGroupsActionTypes.SET_IDS_DISHES;
	payload: {
		IDsSelectedDishes: string[];
	};
}

interface IChangeNameOfModifierGroup {
	type: EditModifierGroupsActionTypes.CHANGE_NAME_OF_MODIFIER_GROUP;
	payload: {
		nameOfModifierGroup: string;
	};
}

interface IChangeExternalId {
	type: EditModifierGroupsActionTypes.CHANGE_EXTERNAL_ID;
	payload: {
		externalId: string;
	};
}

interface ISetDefaultCustomerLanguage {
	type: EditModifierGroupsActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE;
	payload: {
		defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	};
}

interface ISetTranslationTab {
	type: EditModifierGroupsActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: TLanguageIDs | null;
	};
}

interface IChangeTranslation {
	type: EditModifierGroupsActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IMenuTranslation[];
	};
}

interface ISetDataForSubmit {
	type: EditModifierGroupsActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IUpdateModifierGroups | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: EditModifierGroupsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IShowErrorModalWithInfo {
	type: EditModifierGroupsActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IServerError<ICreateModifierGroupValidationError> | null;
	};
}

interface IResetSelectedControls {
	type: EditModifierGroupsActionTypes.RESET_FIELDS;
}

export type TEditModifierGroupsAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| IChangeLoaderStatus
	| IChangeVisibleForm
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDsRestaurant
	| ISetIDsIsForceDisabledRestaurant
	| ISetFetchedCategories
	| ISetIDsCategories
	| ISetFetchedSubcategories
	| ISetIDsSubcategories
	| ISetFetchedDishes
	| ISetIDsDishes
	| IChangeNameOfModifierGroup
	| IChangeExternalId
	| ISetDefaultCustomerLanguage
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo
	| IResetSelectedControls;
